import React, { useEffect, useState } from "react";
import { Card, Container } from "reactstrap";
import DataTable from "react-data-table-component";
import { getDb } from "../../util/Constants";
import { collection, doc, getDocs } from "firebase/firestore";
import moment from "moment";

function Payments() {
  const column = [
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Max Assessments",
      selector: (row) => (row?.maxAssessments ? row?.maxAssessments : 0),
    },
    {
      name: "Max Users",
      selector: (row) => (row?.maxUsers ? row?.maxUsers : 0),
    },
    {
      name: "Payment",
      selector: (row) => row?.plan?.amount / 100,
    },
    {
      name: "Next Payment",
      // parse using moment
      selector: (row) =>
        row?.subscription?.nextPaymentDate
          ? moment.unix(row?.subscription?.nextPaymentDate).format("DD/MM/YYYY")
          : "Not a stripe user",
    },
  ];
  const [payments, setPayments] = useState([]);
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      setLoad(true);
      const db = getDb();
      const paymentsRef = collection(db, "payments");
      // orderby desc createdAt

      const allPayments = getDocs(paymentsRef);
      const paymentsData = (await allPayments).docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setPayments(paymentsData);
      setLoad(false);
    };
    loadData().then((r) => console.log(r));
  }, []);
  return (
    <>
      <Container fluid>
        <Card>
          <DataTable
            columns={column}
            data={payments}
            progressPending={load}
            pagination={true}
          />
        </Card>
      </Container>
    </>
  );
}

export default Payments;
